import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["collectionForm"]

  selectAll(event) {
    this.element.querySelectorAll('tbody input[type=checkbox]').forEach(cb => {
      cb.checked = event.target.checked
    })
  }

  readSelected() {
    this.element.querySelector('#operation').value = "read"
    this.collectionFormTarget.requestSubmit()
  }

  removeSelected() {
    this.element.querySelector('#operation').value = "remove"
    this.collectionFormTarget.requestSubmit()
  }
}
